module.exports = __webpack_public_path__ + "img/reset-hdtool.9bd37297.png";